import { handleResponse, handleError } from "./apiUtils";
import { saveAs } from "file-saver";

//let baseUrl = (process.env.REACT_APP_API_URL || "") + "/api/Prize/";
const baseUrlPremium = "/api/Prize/";

//Gets all reported premiums by organisation
export async function getPremiums(org, year, compId) {
  try {
    const response = await fetch(
      baseUrlPremium + "Org/" + org + "?year=" + year + "&compId=" + compId,
      {
        method: "GET",
        headers: new Headers({
          Authorization: "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
          "Content-Type": "application/json",
        }),
      }
    );
    return handleResponse(response);
  } catch (error) {
    return handleError(error);
  }
}

//Get reported premium
export async function getPremium(prizeId) {
  try {
    const response = await fetch(baseUrlPremium + "Id/" + prizeId, {
      method: "GET",
      headers: new Headers({
        Authorization: "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
        "Content-Type": "application/json",
      }),
    });
    return handleResponse(response);
  } catch (error) {
    return handleError(error);
  }
}

//Gets last year's reported premium
export async function getLastYearsPremium(compId, year) {
  try {
    const response = await fetch(`${baseUrlPremium}MembershipId/${compId}?Year=${year}`, {
      method: "GET",
      headers: new Headers({
        Authorization: "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
        "Content-Type": "application/json",
      }),
    });
    return handleResponse(response);
  } catch (error) {
    return handleError(error);
  }
}

//New Premium
export async function newPremium(premium, returnError = false) {
  console.log(premium)
  try {
    const response = await fetch(`${baseUrlPremium}NewPrize`, {
      method: "POST",
      headers: new Headers({
        Authorization: "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
        "Content-Type": "application/json",
      }),
      body: JSON.stringify(premium),
    });

    const result = await handleResponse(response, returnError);
    return result;
  } catch (error) {
    return handleError(error);
  }
}

// Transfer Premium to TFF Code
export async function transferPremiumToTffCode(transferRequest, returnError = false) {
  try {
    const response = await fetch(`${baseUrlPremium}TransferPrizeToTffCode`, {
      method: "POST",
      headers: new Headers({
        Authorization: "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
        "Content-Type": "application/json",
      }),
      body: JSON.stringify(transferRequest),
    });

    const result = await handleResponse(response, returnError);
    return result;
  } catch (error) {
    return handleError(error);
  }
}


//Gets premium ownership history for prizeId
export async function getOwnerships(prizeId) {
  try {
    const response = await fetch(baseUrlPremium + "Ownership/" + prizeId, {
      method: "GET",
      headers: new Headers({
        Authorization: "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
        "Content-Type": "application/json",
      }),
    });
    return handleResponse(response);
  } catch (error) {
    return handleError(error);
  }
}

//Update Premium
export async function updatePremium(premium, returnError = false) {
  console.log(premium)
  try {
    const response = await fetch(baseUrlPremium + "UpdatePrize", {
      method: "PUT",
      headers: new Headers({
        Authorization: "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
        "Content-Type": "application/json",
      }),
      body: JSON.stringify(premium),
    });
    return handleResponse(response, returnError);
  } catch (error) {
    return handleError(error);
  }
}

//TFF markedsandeler data import
export async function TFFDataImport(files, prizeYear) {
  var formData = new FormData();
  for (var i = 0; i !== files.length; i++) {
    formData.append("file", files[i]);
  }

  return fetch("/api/Data/CodeTFF?prizeYear=" + prizeYear, {
    method: "POST",
    // processData: false,
    // contentType: false,
    headers: new Headers({
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
    }),
    body: formData,
  })
    .then(async (response) => {
      if (response.status === 401) {
        sessionStorage.removeItem("token");
        return undefined;
      } else if (response.ok) {
        return response.json();
      } else {
        return false;
      }
    })
    .catch((error) => {
      console.error("API call failed. " + error);
    });
}

//New premium ownerhsip history for prizeId
export async function newOwnership(org, prizeId, ownership) {
  try {
    const response = await fetch(baseUrlPremium + "Ownership/" + org + "/" + prizeId, {
      method: "POST",
      headers: new Headers({
        Authorization: "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
        "Content-Type": "application/json",
      }),
      body: JSON.stringify(ownership),
    });
    return handleResponse(response);
  } catch (error) {
    return handleError(error);
  }
}

//Updates premium ownership history for prizeId
export async function updateOwnership(org, prizeId, ownerhsip) {
  try {
    const response = await fetch(baseUrlPremium + "Ownership/" + org + "/" + prizeId, {
      method: "PUT",
      headers: new Headers({
        Authorization: "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
        "Content-Type": "application/json",
      }),
      body: JSON.stringify(ownerhsip),
    });
    return handleResponse(response);
  } catch (error) {
    return handleError(error);
  }
}

//Gets vintages and shows if they are ended
export async function getVintages(org) {
  try {
    const response = await fetch(baseUrlPremium + "Org/" + org + "/Vintage", {
      method: "GET",
      headers: new Headers({
        Authorization: "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
        "Content-Type": "application/json",
      }),
    });
    return handleResponse(response);
  } catch (error) {
    return handleError(error);
  }
}

//Gets vintage for a specific year
export async function getVintagesByYear(org, year, companyId) {
  try {
    const response = await fetch(baseUrlPremium + "Org/" + org + "/Vintage/" + year + "?companyId=" + companyId, {
      method: "GET",
      headers: new Headers({
        Authorization: "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
        "Content-Type": "application/json",
      }),
    });
    return handleResponse(response);
  } catch (error) {
    return handleError(error);
  }
}

//Download excel for vintage
export async function getExcelFile(org, year, companyId, download) {
  return fetch(
    `${baseUrlPremium}Org/${org}/Vintage/${year}?companyId=${companyId}&export=${download}`,
    {
      method: "GET",
      headers: new Headers({
        Authorization:
          "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
        "Content-Type": "Content-Type/attachment",
      }),
      responseType: "blob",
    }
  )
    .then(async (response) => {
      if (response.status === 401) {
        sessionStorage.removeItem("token");
        return undefined;
      } else {
        const filename = response.headers
          .get("content-disposition")
          .split(";")
          .find((n) => n.includes("filename="))
          .replace("filename=", "")
          .trim()
          .replace(/^"(.*)"$/, "$1");
        const blob = await response.blob();
        saveAs(blob, filename);
      }
    })
    .catch((error) => {
      console.error("API call failed. " + error);
    });
}

//Update Premium
export async function endVintage(org, year, ended) {
  return fetch(
    baseUrlPremium + "Org/" + org + "/Vintage/" + year + "?Ended=" + ended,
    {
      method: "PUT",
      headers: new Headers({
        Authorization:
          "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
        "Content-Type": "text/plain",
      }),
    }
  )
    .then(async (response) => {
      if (response.status === 401) {
        sessionStorage.removeItem("token");
        return undefined;
      } else if (response.ok) {
        return await response.text();
      } else {
        return false;
      }
    })
    .catch((error) => {
      console.error("API call failed. " + error);
    });
}

export async function getYearsTFF() {
  try {
    const response = await fetch("/api/Data/Summoning/Years/TFF", {
      method: "GET",
      headers: new Headers({
        Authorization: "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
        "Content-Type": "application/json",
      }),
    });
    return handleResponse(response);
  } catch (error) {
    return handleError(error);
  }
}
